import api from './api';
import { getApiURL } from './servers';
import * as endpoints from '../constants/servicesRoutes'; 

export const login = (data: any) =>
  api.post(`${getApiURL()}${endpoints.LOGIN}`, data);